import {
  Autocomplete,
  Box,
  BoxProps,
  CircularProgress,
  TextField,
} from "@mui/material";
import React from "react";
import { entityStringLabel } from "../../../utils";

interface Props<T> extends Omit<BoxProps, "defaultValue"> {
  label: string;
  data?: T[];
  keys: (keyof T)[];
  loading: boolean;
  value?: T | null;
  defaultValue?: T;
  onOptionSelected: (entity: T | null) => void;
}

export const Dropdown = <T,>(props: Props<T>) => {
  const {
    data,
    loading,
    keys,
    label,
    value,
    defaultValue,
    onOptionSelected,
    ...rest
  } = props;
  return (
    <Box {...rest}>
      <Autocomplete
        id={label}
        fullWidth
        isOptionEqualToValue={() => true}
        getOptionLabel={(option) => entityStringLabel(option, keys)}
        onChange={(_, value) => onOptionSelected(value)}
        options={data ?? []}
        loading={loading}
        {...(value !== undefined ? { value: value ?? null } : {})}
        {...(defaultValue !== undefined ? { defaultValue } : {})}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    </Box>
  );
};
